import React, { useEffect, useState } from "react";
import OTPInput from "react-otp-input";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../../SharedComponents/Loader/Loader";
import classes from "./Login.module.css";
import {
  CatchMessage,
  JSONtoformdata,
  secondsToMinutesAndSeconds,
} from "../../Shared/Methods";
import CommonButton from "../../Components/Buttons/CommonButton";
import { handleloading } from "../../Store/Redux/Reducers/Dashboardreducers";
import { ResendOtp, VerifyOtp } from "../../Services/ApiServices";
import { ProjectID } from "../../Shared/Constants";

// const validation = Yup.object().shape({
//   otpone: Yup.string().required("otp is required"),
//   otptwo: Yup.string().required("otp is required"),
//   otpthree: Yup.string().required("otp is required"),
//   otpfour: Yup.string().required("otp is required"),
//   otpfive: Yup.string().required("otp is required"),
//   otpsix: Yup.string().required("otp is required"),
// });

function OtpVerification() {
  const { loading } = useSelector((state: any) => state.Dashboard);
  const [count, setCount] = useState<number>(60);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location;
  const { response } = state ? state : "";
  const { reset_key, email, mobileNumber, org_code, frompassword } = response
    ? response
    : "";
  const [otp, setOtp] = useState("");
  const [isotperror, setotperror] = useState(false);

  // const { values, errors, touched, handleSubmit, handleChange, setFieldValue } =
  //   useFormik({
  //     initialValues: {
  //       otpone: "",
  //       otptwo: "",
  //       otpthree: "",
  //       otpfour: "",
  //       otpfive: "",
  //       otpsix: "",
  //     },
  //     validationSchema: validation,
  //     onSubmit: (values) => {
  //       handleVerifyOTP();
  //     },
  //   });

  useEffect(() => {
    const interval = setInterval(() => {
      if (count > 0) {
        setCount(count - 1);
      } else {
        clearInterval(interval);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, [count]);

  // const handleVerifyOTP = () => {
  //   dispatch(handleloading(true));

  //   const finalObj = {
  //     otp:
  //       values.otpone +
  //       values.otptwo +
  //       values.otpthree +
  //       values.otpfour +
  //       values?.otpfive +
  //       values.otpsix,
  //     reset_key: reset_key,
  //   };

  //   VerifyOtp(JSONtoformdata(finalObj))
  //     .then((res) => {
  //       if (res?.data?.status === 1) {
  //         navigate("/");
  //         toast.success(res?.data?.msg);
  //       } else if (res?.data?.status === 0) {
  //         toast.error(res?.data?.msg);
  //       }
  //     })
  //     .catch((err) => {
  //       CatchMessage(err);
  //     })
  //     .finally(() => dispatch(handleloading(false)));
  // };

  const handleRsendOTP = () => {
    dispatch(handleloading(true));
    const finalObj = {
      reset_key: reset_key,
      email: email,
      ...ProjectID,
      org_code: org_code,
    };

    ResendOtp(JSONtoformdata(finalObj))
      .then((res) => {
        if (res?.data?.status === 1) {
          setCount(60);
          toast.success(res?.data?.msg);
          setOtp("");
          navigate("/otpverification", {
            state: {
              response: {
                ...res?.data,
                email: email,
                org_code: org_code,
                frompassword: frompassword,
              },
            },
          });
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  useEffect(() => {
    const disableBackNavigation = (event: PopStateEvent) => {
      event.preventDefault();
      navigate(-1);
    };

    // window.history.pushState(null, "/");
    window.addEventListener("popstate", disableBackNavigation);

    return () => {
      window.removeEventListener("popstate", disableBackNavigation);
    };
  }, []);

  const handleVerifyOTP = () => {
    dispatch(handleloading(true));

    const finalObj = {
      otp: otp,
      reset_key: reset_key,
      ...ProjectID,
      org_code: org_code,
    };

    VerifyOtp(JSONtoformdata(finalObj))
      .then((res) => {
        if (res?.data?.status === 1) {
          if (frompassword) {
            navigate("/changepassword", { state: { response: response } });
          } else {
            navigate("/");
          }
          toast.success(res?.data?.msg);
        } else if (res?.data?.status === 0) {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        CatchMessage(err);
      })
      .finally(() => dispatch(handleloading(false)));
  };

  return (
    <>
      <Loader isLoader={loading} />
      <p className={classes.login_text} style={{ marginBottom: "4px" }}>
        OTP Verification
      </p>
      {/* <p style={{ textAlign: "center" }}>
        Enter OTP Code sent to *{mobileNumber?.split("")[0]}
        {mobileNumber?.split("")[1]}
        {mobileNumber?.split("")[2]}
        {mobileNumber?.split("")[3]}*********{mobileNumber?.split("")[8]}
        {mobileNumber?.split("")[9]}
      </p> */}
      <p style={{ textAlign: "center", marginBottom: "36px" }}>
        Enter OTP Code sent to {email}
      </p>
      <div
        // onSubmit={handleSubmit}
        className={`primaryInput otpinput`}
        id="remove_image"
      >
        {/* <Row className={classes.otptext} gutter={[16, 16]}>
          <Col xs={4}>
            <CommonInput
              name="otpone"
              value={values?.otpone}
              error={errors}
              onChange={(e) => {

                setFieldValue("otpone", e.target.value);
              }}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              onKeyDown={handleEnter}
            />
          </Col>
          <Col xs={4}>
            <CommonInput
              name="otptwo"
              value={values?.otptwo}
              error={errors}
              onChange={(e) => {

                setFieldValue("otptwo", e.target.value);
              }}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              onKeyDown={handleEnter}
            />
          </Col>
          <Col xs={4}>
            <CommonInput
              name="otpthree"
              value={values?.otpthree}
              error={errors}
              onChange={handleChange}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              onKeyDown={handleEnter}
            />
          </Col>

          <Col xs={4}>
            <CommonInput
              name="otpfour"
              value={values?.otpfour}
              error={errors}
              onChange={handleChange}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              onKeyDown={handleEnter}
            />
          </Col>
          <Col xs={4}>
            <CommonInput
              name="otpfive"
              value={values?.otpfive}
              error={errors}
              onChange={handleChange}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              onKeyDown={handleEnter}
            />
          </Col>
          <Col xs={4}>
            <CommonInput
              name="otpsix"
              value={values?.otpsix}
              error={errors}
              onChange={handleChange}
              touched={touched}
              maxLength={lengths.OTPLength}
              type="text"
              //   onKeyDown={handleEnter}
              onKeyDown={(e: any) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            />
          </Col>
        </Row> */}

        <OTPInput
          value={otp}
          onChange={(e) => {
            setOtp(e);
            // setotperror(true);
          }}
          renderInput={(props) => <input {...props} />}
          numInputs={6}
          shouldAutoFocus={true}
        />
        {/* 
        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", left: "40%" }}>
            {errors ? (
              (errors.otpone && touched?.otpone) ||
              (errors.otptwo && touched?.otptwo) ||
              (errors.otpthree && touched?.otpthree) ||
              (errors.otpfour && touched?.otpfour) ||
              (errors.otpfive && touched?.otpfive) ||
              (errors.otpsix && touched?.otpsix) ? (
                <p className={classes.otprequiredtext}>OTP is required</p>
              ) : null
            ) : null}
          </div>
        </div> */}

        <div style={{ position: "relative" }}>
          <div style={{ position: "absolute", left: "40%" }}>
            {isotperror && otp.length !== 6 ? (
              <p className={classes.otprequiredtext}>OTP is required</p>
            ) : null}
          </div>
        </div>

        {count === 0 ? (
          <p className={classes.resend_code}>
            Don't receive OTP Code?{" "}
            <span
              style={{ color: "#20a2a0", cursor: "pointer" }}
              onClick={() => {
                // setCount(60);
                handleRsendOTP();
              }}
            >
              Resend Code
            </span>
          </p>
        ) : (
          <p className={classes.resend_code}>
            Resend OTP in{" "}
            <span style={{ color: "#20a2a0", cursor: "pointer" }}>
              {secondsToMinutesAndSeconds(count)}
            </span>
          </p>
        )}

        <div
          className={classes.btn_container}
          style={{
            width: "225px",
            margin: "25px auto 15px",
            // marginTop: "15px",
          }}
        >
          <CommonButton
            name="Verify & Proceed"
            style={{
              border: "none",
              width: "100px",
              height: "38px",
              color: "white",
              borderRadius: "7px",
            }}
            onClick={() => {
              setotperror(otp?.length !== 6);
              if (otp?.length === 6) {
                handleVerifyOTP();
              }
            }}
            type="submit"
            classname="submit_btn"
          />
        </div>
      </div>
    </>
  );
}

export default OtpVerification;
